export default __webpack_public_path__ + "static/media/sub-category-fitness-fitness.6e1ea095.jpg";